'use client'

import { createContext, use } from 'react'

interface InitializationContext {
  isReady: boolean
  isInitializing: boolean | null
  hasInitialized: boolean
  initializationError: string | null
  isEmailVerified: boolean
  setIsEmailVerified: (isEmailVerified: boolean) => void
}

export const InitializationContext = createContext<InitializationContext>({
  isReady: false,
  isInitializing: null,
  hasInitialized: false,
  initializationError: null,
  isEmailVerified: false,
  setIsEmailVerified: () => {},
})

export const useInitializationContext = () => {
  const context = use(InitializationContext)

  if (!context) {
    throw new Error('useInitializationContext must be used within an InitializationProvider')
  }

  return context
}
